const useFullscreen = () => {
  const isInFullscreen = document.fullscreenElement !== null;

  const toggle = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  };

  return { isInFullscreen, toggle };
};

export { useFullscreen };
